/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getSuspectedDuplicateUserQueueResponse = zod.object({
  "suspectedDuplicateUsers": zod.array(zod.object({
  "id": zod.string().uuid(),
  "suspectedDate": zod.string().datetime({}),
  "provenDate": zod.string().datetime({}).nullish(),
  "preferredSurvivorUserId": zod.string().uuid().nullish(),
  "user": zod.object({
  "userId": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "fullName": zod.string().nullish(),
  "emails": zod.array(zod.string()),
  "createdDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}).nullish()
}),
  "otherUser": zod.object({
  "userId": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "fullName": zod.string().nullish(),
  "emails": zod.array(zod.string()),
  "createdDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}).nullish()
}),
  "emailCollisionCount": zod.number(),
  "ssoIdentityCollisionCount": zod.number(),
  "rosterEmailCollisionCount": zod.number(),
  "rosterNameAndPhoneCollisionCount": zod.number(),
  "astraIdentityCollisionCount": zod.number(),
  "isClean": zod.boolean(),
  "selfService": zod.enum(['ChooseSurvivor', 'SurvivorFixed', 'SupportRequired'])
})),
  "quarantinedCollisions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "type": zod.enum(['SubmissionMismatch', 'TalentBindingConflict', 'OrganizationBindingConflict']),
  "submittedEmail": zod.string(),
  "submittedPhone": zod.string().nullish(),
  "submittedFullName": zod.string().nullish(),
  "storedAstraUserId": zod.string().nullish(),
  "resolvedAstraUserId": zod.string(),
  "resolvedEmail": zod.string().nullish(),
  "resolvedFullName": zod.string().nullish(),
  "suspectedDuplicateUserId": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({})
}))
})

export const getSuspectedDuplicateUserParams = zod.object({
  "id": zod.string().uuid()
})

export const getSuspectedDuplicateUserResponse = zod.object({
  "id": zod.string().uuid(),
  "status": zod.enum(['Open', 'Merged', 'NotADuplicate', 'KeptApart']),
  "suspectedDate": zod.string().datetime({}),
  "provenDate": zod.string().datetime({}).nullish(),
  "preferredSurvivorUserId": zod.string().uuid().nullish(),
  "resolvedDate": zod.string().datetime({}).nullish(),
  "resolvedByUserId": zod.string().uuid().nullish(),
  "user": zod.object({
  "user": zod.object({
  "userId": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "fullName": zod.string().nullish(),
  "emails": zod.array(zod.string()),
  "createdDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}).nullish()
}),
  "isBoundToPaymentProvider": zod.boolean(),
  "hasApprovedIdentityVerification": zod.boolean(),
  "hasBankAccount": zod.boolean(),
  "hasDebitCard": zod.boolean(),
  "hasPrimaryPaymentDestination": zod.boolean(),
  "hasPayouts": zod.boolean(),
  "isSimple": zod.boolean(),
  "staffRoles": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().nullish()
})),
  "rosterRows": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().nullish(),
  "talentMemberId": zod.string().uuid(),
  "hasActivity": zod.boolean()
}))
}),
  "otherUser": zod.object({
  "user": zod.object({
  "userId": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "fullName": zod.string().nullish(),
  "emails": zod.array(zod.string()),
  "createdDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({}).nullish()
}),
  "isBoundToPaymentProvider": zod.boolean(),
  "hasApprovedIdentityVerification": zod.boolean(),
  "hasBankAccount": zod.boolean(),
  "hasDebitCard": zod.boolean(),
  "hasPrimaryPaymentDestination": zod.boolean(),
  "hasPayouts": zod.boolean(),
  "isSimple": zod.boolean(),
  "staffRoles": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().nullish()
})),
  "rosterRows": zod.array(zod.object({
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().nullish(),
  "talentMemberId": zod.string().uuid(),
  "hasActivity": zod.boolean()
}))
}),
  "isClean": zod.boolean(),
  "selfService": zod.enum(['ChooseSurvivor', 'SurvivorFixed', 'SupportRequired']),
  "fixedSurvivorUserId": zod.string().uuid().nullish(),
  "contestedArtifacts": zod.array(zod.object({
  "kind": zod.enum(['PaymentProviderIdentity', 'MoneyRails', 'PayoutLedger', 'RosterRow', 'StaffRole']),
  "organizationId": zod.string().uuid().nullish(),
  "organizationName": zod.string().nullish(),
  "requiresChoice": zod.boolean()
})),
  "emailCollisions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "otherUserId": zod.string().uuid(),
  "kind": zod.enum(['EmailVerifiedOnBothUsers', 'EmailIsOtherUsersPrimaryEmail']),
  "email": zod.string(),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({})
})),
  "ssoIdentityCollisions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "otherUserId": zod.string().uuid(),
  "providerId": zod.string(),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({})
})),
  "rosterEmailCollisions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().nullish(),
  "talentMemberId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "otherUserId": zod.string().uuid(),
  "email": zod.string(),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({})
})),
  "rosterNameAndPhoneCollisions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().nullish(),
  "talentMemberId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "otherUserId": zod.string().uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "phone": zod.string(),
  "firstSeenDate": zod.string().datetime({}),
  "lastSeenDate": zod.string().datetime({})
})),
  "astraIdentityCollisions": zod.array(zod.object({
  "id": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "type": zod.enum(['SubmissionMismatch', 'TalentBindingConflict', 'OrganizationBindingConflict']),
  "submittedEmail": zod.string(),
  "submittedPhone": zod.string().nullish(),
  "submittedFullName": zod.string().nullish(),
  "storedAstraUserId": zod.string().nullish(),
  "resolvedAstraUserId": zod.string(),
  "resolvedEmail": zod.string().nullish(),
  "resolvedFullName": zod.string().nullish(),
  "suspectedDuplicateUserId": zod.string().uuid().nullish(),
  "createdDate": zod.string().datetime({})
}))
})

export const mergeSuspectedDuplicateUserParams = zod.object({
  "id": zod.string().uuid()
})

export const mergeSuspectedDuplicateUserBody = zod.object({
  "survivorUserId": zod.string().uuid(),
  "choices": zod.array(zod.object({
  "kind": zod.enum(['PaymentProviderIdentity', 'MoneyRails', 'PayoutLedger', 'RosterRow', 'StaffRole']),
  "organizationId": zod.string().uuid().nullish(),
  "keepUserId": zod.string().uuid()
}))
})

export const mergeSuspectedDuplicateUserResponse = zod.object({
  "id": zod.string().uuid(),
  "suspectedDuplicateUserId": zod.string().uuid(),
  "survivorUserId": zod.string().uuid(),
  "absorbedUserId": zod.string().uuid(),
  "mergedDate": zod.string().datetime({})
})

export const dismissSuspectedDuplicateUserAsNotADuplicateParams = zod.object({
  "id": zod.string().uuid()
})

export const keepSuspectedDuplicateUserApartParams = zod.object({
  "id": zod.string().uuid()
})

